import { render, staticRenderFns } from "./Initial.vue?vue&type=template&id=b546541c&scoped=true&"
import script from "./Initial.vue?vue&type=script&lang=js&"
export * from "./Initial.vue?vue&type=script&lang=js&"
import style0 from "./Initial.vue?vue&type=style&index=0&id=b546541c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b546541c",
  null
  
)

export default component.exports